import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import ProductCard from './ProductCard';
import { fetchProductsByCategory, mapProductToCard } from '../utils/productStorefront';

const BOTTOM_WEAR_CATEGORY = 'bottom wear';

const PantyCollection = ({ onAddToCart, catalogReady }) => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    if (!catalogReady) return;
    let cancelled = false;

    const loadBottomWear = async () => {
      try {
        const items = await fetchProductsByCategory(BOTTOM_WEAR_CATEGORY);
        if (items.length === 0) return;

        const mapped = await Promise.all(
          items.map((p) => mapProductToCard(p, { withColors: false }))
        );
        if (!cancelled) setProducts(mapped);
      } catch {
        /* API only */
      }
    };

    loadBottomWear();
    return () => {
      cancelled = true;
    };
  }, [catalogReady]);

  if (products.length === 0) return null;

  return (
    <section className="py-5">
      <Container>
        <Row className="g-4">
          {products.map((product) => (
            <Col key={product.id} lg={4} md={6} sm={6} xs={6}>
              <ProductCard
                product={product}
                onAddToCart={onAddToCart}
                variant="minimalist"
              />
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default PantyCollection;
